/**
 * @author 陈韦润
 * @param name 要修饰的名称
 * @param len 长度
 */
export default function formatName(name, len = 2) {
    let _name = name || '';
    const isEn = /^[A-Za-z,. ]+$/.test(_name);
    // prettier-ignore
    // eslint-disable-next-line max-len
    _name = _name.replace(/[ |~|`|!|@|#|$|%|^|&|*|(|)|\-|_|+|=|||\\|[|\]|{|}|;|:|"|'|,|<|.|>|/|?|。|？|！|，|、|；|：|“|”|‘|’|（|）|《|》|〈|〉|【|】|『|』|「|」|﹃|﹄|〔|〕|…|—|～|﹏|￥]/g, isEn ? ' ' : '');
    if (_name.indexOf(' ') !== -1) {
        _name = _name
            .split(' ')
            .map(p => p.slice(0, 1))
            .join('');
    }
    return (isEn ? _name.slice(0, len) : _name.slice(_name.length - len, _name.length)).toUpperCase();
}
